module.exports = __webpack_public_path__ + "static/media/students.d4f7db0f.svg";